module.exports = __webpack_public_path__ + "static/media/Food_ordering.f78f0384.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Food_ordering.svg
// module id = 508
// module chunks = 11